import classNames from 'classnames/bind';
import styles from './MultipleEnrollment.module.scss';
import Button from '../../../../components/Button';
import {
  EnrollmentStep,
  EnrollmentType,
  TemplateUploadStatus,
} from '../../../../state/enrollment/enrollmentModel';
import {
  setActiveStep,
  uploadTemplateFile,
} from '../../../../state/enrollment/enrollmentActions';
import { ButtonTheme } from '../../../../components/Button/Button';
import { useRef, useState } from 'react';
import { IconName } from '../../../../components/Icon/utils/types';
import { BULK_TEMPLATE_URL } from '../../../../state/enrollment/enrollmentApi';

const cx = classNames.bind(styles);

interface MultipleEnrollmentProps {
  enrollmentType: EnrollmentType;
  templateUploadStatus: TemplateUploadStatus;
  templateUploadError?: string;
  uploadTemplateFile: typeof uploadTemplateFile;
  setActiveStep: typeof setActiveStep;
}

const MultipleEnrollment = (props: MultipleEnrollmentProps) => {
  const {
    templateUploadStatus,
    templateUploadError,
    uploadTemplateFile,
    setActiveStep,
  } = props;
  const [hasDownloadedTemplate, setHasDownloadedTemplate] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null!);

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      uploadTemplateFile(event.target.files[0]);
    }
    fileInputRef.current.value = '';
  };

  const downloadTemplateFile = () => {
    window.location.href = BULK_TEMPLATE_URL;
    setHasDownloadedTemplate(true);
  };

  const renderErrors = () => {
    if (!templateUploadError) return null;

    let errorMessages = [];

    if (Array.isArray(templateUploadError)) {
      errorMessages = templateUploadError;
    } else {
      const errorString = String(templateUploadError);
      errorMessages = errorString.split('|').filter((msg) => msg.trim() !== '');
    }

    return (
      <div className={cx('multiple-enrollment__error')}>
        {errorMessages.map((error, index) => (
          <div key={index} className={cx('multiple-enrollment__error')}>
            {String(error).trim()}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <label className={cx('multiple-enrollment__label')}>STEPS</label>
      <Button
        onClick={downloadTemplateFile}
        className={cx('multiple-enrollment__template-btn')}
        icon={hasDownloadedTemplate ? IconName.Success : undefined}
        theme={ButtonTheme.Light}
      >
        Download Template
      </Button>
      <Button
        onClick={() => fileInputRef.current.click()}
        isLoading={templateUploadStatus === TemplateUploadStatus.UPLOADING}
        className={cx('multiple-enrollment__template-btn')}
        icon={
          templateUploadStatus === TemplateUploadStatus.SUCCESS
            ? IconName.Success
            : templateUploadStatus === TemplateUploadStatus.FAIL
              ? IconName.Error
              : undefined
        }
        theme={ButtonTheme.Light}
      >
        Upload Completed Template
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={onFileChange}
        className={cx('multiple-enrollment__file-input')}
      />
      {templateUploadError && renderErrors()}
      <div className={cx('multiple-enrollment__footer')}>
        <Button
          onClick={() => setActiveStep(EnrollmentStep.REVIEW)}
          disabled={templateUploadStatus !== TemplateUploadStatus.SUCCESS}
          className={cx('multiple-enrollment__save-btn')}
        >
          Save & Continue
        </Button>
      </div>
    </>
  );
};

export default MultipleEnrollment;
